
export default function ContactMap() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Notre <span className="text-red-600">Localisation</span>
          </h2>
          <p className="text-lg text-gray-600">
            Venez nous rendre visite dans nos locaux à Tunis
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="bg-gray-100 rounded-2xl overflow-hidden shadow-lg h-96">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3194.7!2d10.1882079!3d36.7964878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd346b418c8401%3A0x63997deff9c0a3bf!2s7%20Rue%20Ali%20Darghouth%2C%20Tunis!5e0!3m2!1sfr!2stn!4v1635789012345!5m2!1sfr!2stn"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localisation Cobra Sécurité"
              ></iframe>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-gray-50 rounded-2xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Informations Pratiques</h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-map-pin-line text-red-600 text-xl mt-1"></i>
                  <div>
                    <div className="font-medium text-gray-900">Adresse</div>
                    <div className="text-gray-600">7, rue Ali Darghouth<br />Tunis, Tunisie</div>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <i className="ri-phone-line text-red-600 text-xl mt-1"></i>
                  <div>
                    <div className="font-medium text-gray-900">Téléphone</div>
                    <div className="text-gray-600">71 348 109</div>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <i className="ri-time-line text-red-600 text-xl mt-1"></i>
                  <div>
                    <div className="font-medium text-gray-900">Horaires</div>
                    <div className="text-gray-600">Du lundi au samedi<br />8h00 - 18h00</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-red-50 rounded-2xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Zone d'Intervention</h3>
              <p className="text-gray-600 mb-4">
                Nous intervenons dans toute la Tunisie pour répondre à vos besoins de sécurité.
              </p>
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <i className="ri-check-line text-red-600"></i>
                  <span className="text-gray-700">Grand Tunis et environs</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-check-line text-red-600"></i>
                  <span className="text-gray-700">Nord : Bizerte, Béja, Jendouba</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-check-line text-red-600"></i>
                  <span className="text-gray-700">Centre : Sousse, Monastir, Kairouan</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-check-line text-red-600"></i>
                  <span className="text-gray-700">Sud : Sfax, Gabès, Tozeur</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-check-line text-red-600"></i>
                  <span className="text-gray-700">Toutes autres régions</span>
                </div>
              </div>
            </div>

            <button className="w-full bg-red-600 text-white py-4 rounded-2xl font-medium hover:bg-red-700 transition-colors">
              <i className="ri-navigation-line mr-2"></i>
              Itinéraire GPS
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
